/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Action_CommunitiesInputs */

const en_footer_action_communities = /** @type {(inputs: Footer_Action_CommunitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Communities`)
};

/**
* | output |
* | --- |
* | "Communities" |
*
* @param {Footer_Action_CommunitiesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_action_communities = /** @type {((inputs?: Footer_Action_CommunitiesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Action_CommunitiesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_action_communities(inputs)
});